document.addEventListener('DOMContentLoaded', function() {
  const imageGridItems = document.querySelectorAll('.image-grid__item.has-hover-button');
  
  if (imageGridItems.length > 0) {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    imageGridItems.forEach(item => {
      if (isMobile) {
        item.addEventListener('touchstart', function(e) {
          imageGridItems.forEach(otherItem => {
            if (otherItem !== item) {
              otherItem.classList.remove('touch-active');
            }
          });
          
          item.classList.toggle('touch-active');
          
          if (item.classList.contains('touch-active')) {
            e.preventDefault();
          }
        });
        
        document.addEventListener('touchstart', function(e) {
          if (!e.target.closest('.image-grid__item')) {
            imageGridItems.forEach(item => {
              item.classList.remove('touch-active');
            });
          }
        });
      }
      
      const link = item.querySelector('.image-grid__link, .image-grid__button a');
      if (link) {
        link.addEventListener('focus', function() {
          item.classList.add('keyboard-focus');
        });
        
        link.addEventListener('blur', function() {
          item.classList.remove('keyboard-focus');
        });
      }
    });
  }
  
  const imageGridImages = document.querySelectorAll('.image-grid__image img');
  
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.classList.add('loaded');
          observer.unobserve(img);
        }
      });
    }, {
      rootMargin: '50px 0px',
      threshold: 0.01
    });
    
    imageGridImages.forEach(img => {
      imageObserver.observe(img);
    });
  }
  
  const parallaxEnabled = false;
  
  if (parallaxEnabled && !isMobile) {
    const parallaxItems = document.querySelectorAll('.image-grid__image img');
    
    window.addEventListener('scroll', () => {
      const scrolled = window.pageYOffset;
      
      parallaxItems.forEach(item => {
        const rect = item.getBoundingClientRect();
        const speed = 0.5;
        
        if (rect.bottom >= 0 && rect.top <= window.innerHeight) {
          const yPos = -(scrolled * speed);
          item.style.transform = `translateY(${yPos}px) scale(1.1)`;
        }
      });
    });
  }
});
    
const style = document.createElement('style');
style.textContent = `
  .image-grid__item.touch-active .image-grid__button.show-on-hover,
  .image-grid__item.keyboard-focus .image-grid__button.show-on-hover {
    opacity: 1;
    transform: translateY(0);
  }
  
  .image-grid__item.touch-active .image-grid__overlay,
  .image-grid__item.keyboard-focus .image-grid__overlay {
    opacity: calc(var(--overlay-opacity) + 0.2);
  }
  
  .image-grid__item.touch-active .image-grid__image img,
  .image-grid__item.keyboard-focus .image-grid__image img {
    transform: scale(1.05);
  }
  
  .image-grid__image img {
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  .image-grid__image img.loaded {
    opacity: 1;
  }
`;
document.head.appendChild(style); 